<template>
  <div v-if="justView" class="mt-2">
    <div class="multiple-question-area">
      <span class="text-addquestion">{{ questionText }}</span>
      <div>
        <div class="itens" v-for="(choice, i) in choices" :key="i">
          <div class="chips-area">
            <span class="chip">
              {{ choice.text }}
            </span>
          </div>
          <div
            style="margin-top: 8px"
            v-for="(subChoice, i) in choice.subOptions"
            :key="i"
          >
            <span class="sub-chip">
              {{ subChoice.text }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <p
      v-if="hasComment"
      class="comment-area"
      :style="{
        color: textColor || '#000000',
      }"
    >
      Comentário: {{ hasComment }}
    </p>
    <hr />
  </div>
  <div v-else class="break-word">
    <div :class="addQuestionTemplate === 'custom' ? 'text-center' : ''">
      <label :style="{
                color: textColor || '#000000',
              }" v-if="questionText">{{ questionText }}</label>
    </div>
    <div
      :style="
        addQuestionTemplate === 'custom'
          ? 'display: flex; align-items: center; justify-content: center'
          : ''
      "
    >
      <div v-if="type === 'radio'">
        <b-form-group style="margin-left: 20px">
          <b-form-radio-group v-model="selectedRadioChoice">
            <b-form-radio
              v-for="(item, index) in multipleList"
              :value="item"
              :key="index"
              @change="update(item)"
              :style="{
                color: textColor || '#000000',
              }"
            >
              <span class="arrow-toggle">
                <i
                  v-if="selectedRadioChoice.text === item.text"
                  class="fas fa-caret-down"
                  style="margin-left: -3px"
                />
                <i v-else class="fas fa-caret-right" />
              </span>
              <template v-if="lang === 'br'">
                {{ item.text ? item.text : '-' }}
              </template>
              <template v-if="lang === 'es'">
                {{ item.textES ? item.textES : '-' }}
              </template>
              <template v-if="lang === 'us'">
                {{ item.textEN ? item.textEN : '-' }}
              </template>
              <b-form-radio-group v-model="selectedRadioSubChoice">
                <template v-if="selectedRadioChoice.text === item.text">
                  <b-form-radio
                    v-for="(subItem, indexSubItem) in item.subChoices"
                    :value="subItem.textPt"
                    :key="indexSubItem"
                    @change="handleSubChoice(index, subItem)"
                  >
                    <template v-if="lang === 'br'">
                      {{ subItem.textPt ? subItem.textPt : '-' }}
                    </template>
                    <template v-if="lang === 'es'">
                      {{ subItem.textEs ? subItem.textEs : '-' }}
                    </template>
                    <template v-if="lang === 'us'">
                      {{ subItem.textEn ? subItem.textEn : '-' }}
                    </template>
                  </b-form-radio>
                </template>
              </b-form-radio-group>
              
            </b-form-radio>
            <b-textarea
                v-show="multipleList.find((item) =>
                  item.isOther &&
                    (lang === 'us' ? item.textEN : lang === 'es' ? item.textES : item.text) ===
                    (lang === 'us' ? selectedRadioChoice.textEN : lang === 'es' ? selectedRadioChoice.textES : selectedRadioChoice.text))
                  "
                id="textarea"
                v-model="otherComment"
                rows="3"
                max-rows="6"
              ></b-textarea>
          </b-form-radio-group>
        </b-form-group>
      </div>
      <div v-if="type === 'checkbox' && !loadingMultipleChoice">
        <b-form-group>
          <b-form-checkbox-group
            v-model="selectedCheckChoice"
            style="margin-left: 20px"
            :style="{
                color: textColor || '#000000',
              }"
          >
            <b-form-checkbox
              v-for="(item, index) in multipleList"
              :value="item"
              :key="index"
              @change="update(item)"
              :disabled="item.disabled"
            >
              <span class="arrow-toggle">
                <i
                  v-if="selectedCheckChoice.find((i) => i.text == item.text)"
                  class="fas fa-caret-down"
                  style="margin-left: -3px"
                />
                <i v-else class="fas fa-caret-right" />
              </span>
              <template v-if="lang === 'br'">
                {{ item.text ? item.text : '-' }}
              </template>
              <template v-if="lang === 'es'">
                {{ item.textES ? item.textES : '-' }}
              </template>
              <template v-if="lang === 'us'">
                {{ item.textEN ? item.textEN : '-' }}
              </template>
              <b-form-checkbox-group v-model="selectedSubCheckChoice">
                <template
                  v-if="selectedCheckChoice.find((i) => i.text == item.text)"
                >
                  <b-form-checkbox
                    v-for="(subItem, indexSubItem) in item.subChoices"
                    :value="subItem"
                    :key="indexSubItem"
                    @change="handleSubChoice(index, subItem)"
                  >
                    <template v-if="lang === 'br'">
                      {{ subItem.textPt ? subItem.textPt : '-' }}
                    </template>
                    <template v-if="lang === 'es'">
                      {{ subItem.textEs ? subItem.textEs : '-' }}
                    </template>
                    <template v-if="lang === 'us'">
                      {{ subItem.textEn ? subItem.textEn : '-' }}
                    </template>
                  </b-form-checkbox>
                </template>
              </b-form-checkbox-group>
            </b-form-checkbox>
            <b-textarea
                v-show="
                    multipleList.some(
                      (item) =>
                        item.isOther &&
                        selectedCheckChoice.some(
                          (choice) =>
                            choice[lang === 'us' ? 'textEN' : lang === 'es' ? 'textES' : 'text'] ===
                            item[lang === 'us' ? 'textEN' : lang === 'es' ? 'textES' : 'text']
                        )
                    )
                "
                id="textarea"
                v-model="otherComment"
                rows="3"
                max-rows="6"
                ></b-textarea>
          </b-form-checkbox-group>
        </b-form-group>
      </div>
    </div>
    <comment-area
      :template="addQuestionTemplate"
      v-if="commentEnabled"
      v-model="comment"
    />
    <hr />
  </div>
</template>
<script>
import commentArea from '../comment-area';
import applicable from '../applicable';

export default {
  name: 'MultipleChoicesCustom',
  components: {
    commentArea,
    applicable,
  },

  props: {
    textColor: {
      type: String,
      required: false,
    },
    type: {
      type: String,
      required: true,
    },
    questionText: {
      type: String,
      required: true,
    },
    choices: {
      type: Array,
      required: true,
    },
    index: {
      type: Number,
    },
    justView: {
      type: Boolean,
    },
    selected: {
      required: false,
    },
    commentEnabled: {
      type: Boolean,
      default: false,
    },
    applicableEnabled: { type: Boolean, default: false },
    hasComment: {
      type: String,
      default: null,
    },
    addQuestionTemplate: { type: String, default: 'default' },
    idQuestion: { type: String, required: false },
    itemId: { type: String, required: false },
    lang: { type: String, required: false, default: 'br' },
    limitChoices: { type: String, required: false, default: '' },
  },

  data: () => ({
    isSelected: null,
    comment: null,
    otherComment: '',
    applicabled: null,
    review: null,
    multipleValuesCustom: [],
    multipleList: [],
    selectedRadioChoice: { text: null },
    selectedRadioSubChoice: { text: null },
    selectedCheckChoice: [],
    selectedSubCheckChoice: [],
    loadingMultipleChoice: false,
  }),

  mounted() {
    this.isSelected = this.selected;
    this.multipleList = this.choices;
  },

  watch: {
    comment: function watchComment() {
      this.update();
    },
    otherComment: function watchOtherComment() {
      this.updateOtherComment();
    },
    applicabled: function watchApplicated(value) {
      this.$emit('input', {
        review: value,
        position: this.itemId,
        _id: this.idQuestion,
      });
    },
  },

  methods: {
    handleSubChoice(indexChoice, subItem) {
      // eslint-disable-next-line no-nested-ternary

      if (this.type === 'checkbox') {
        this.addOrRemoveSubChoiceCheckbox(indexChoice, subItem);
      } else {
        this.addOrRemoveSubChoiceRadio(indexChoice, subItem);
      }
    },

    returnTextByLang(array) {
      // eslint-disable-next-line no-nested-ternary
      const textBylang =
        this.lang === 'br'
          ? array.text || array.textPt
          : this.lang === 'us'
          ? array.textEN || array.textEn
          : array.textES || array.textEn;

      return textBylang;
    },

    addOrRemoveChoiceCheckbox(choice) {
      const textBylang = this.returnTextByLang(choice);

      const index = this.multipleValuesCustom.findIndex(
        (val) => val.id === choice.id && val.text === textBylang,
      );

      if (index < 0) {
        this.multipleValuesCustom.push({
          text: textBylang,
          optionId: choice._id,
          subOptions: [],
          id: choice.id,
        });
      } else {
        const subOptionsSelected = this.multipleValuesCustom[
          index
        ].subOptions.map((item) => item.id);

        this.multipleValuesCustom.splice(index, 1);

        const idsSubOptions = this.selectedSubCheckChoice.map(
          (item) => item.id,
        );

        for (let i = 0; i < subOptionsSelected.length; i += 1) {
          if (idsSubOptions.includes(subOptionsSelected[i])) {
            const indexSubChoice = this.selectedSubCheckChoice.findIndex(
              (value) => value.id === subOptionsSelected[i],
            );

            this.selectedSubCheckChoice.splice(indexSubChoice, 1);
          }
        }
      }
    },

    addOrRemoveSubChoiceCheckbox(indexChoice, subItem) {
      const index = this.multipleValuesCustom.findIndex(
        (item) =>
          item.text === this.returnTextByLang(this.multipleList[indexChoice]),
      );

      let indexSubOption = -1;

      if (this.multipleValuesCustom.length) {
        indexSubOption = this.multipleValuesCustom[index].subOptions.findIndex(
          (item) => item.id === subItem.id,
        );
      }

      if (indexSubOption < 0) {
        this.multipleValuesCustom[index].subOptions.push({
          text: this.returnTextByLang(subItem),
          subOptionId: subItem._id,
          id: subItem.id,
        });
      } else {
        this.multipleValuesCustom[index].subOptions.splice(indexSubOption, 1);
      }
    },

    addOrRemoveChoiceRadio(choice) {
      this.multipleValuesCustom = [];
      this.selectedRadioSubChoice = null;
      this.multipleValuesCustom.push({
        text: this.returnTextByLang(choice),
        optionId: choice._id,
        subOptions: [],
      });
    },

    addOrRemoveSubChoiceRadio(indexChoice, subItem) {
      this.multipleValuesCustom[0].subOptions = [];
      this.multipleValuesCustom[0].subOptions.push({
        text: this.returnTextByLang(subItem),
        subOptionId: subItem._id,
      });
    },

    update(choice) {
      if (this.type === 'checkbox') {
        this.addOrRemoveChoiceCheckbox(choice);

        if (
          this.limitChoices !== '' &&
          this.multipleValuesCustom.length >= Number(this.limitChoices)
        ) {
          this.loadingMultipleChoice = true;
          for (let a = 0; a < this.multipleList.length; a += 1) {
            const objExists = this.multipleValuesCustom.find(
              (obj) => obj.id === this.multipleList[a].id,
            );

            if (objExists) {
              this.multipleList[a].disabled = false;
            } else {
              this.multipleList[a].disabled = true;
            }
          }
          this.loadingMultipleChoice = false;
        } else {
          this.loadingMultipleChoice = true;
          for (let a = 0; a < this.multipleList.length; a += 1) {
            this.multipleList[a].disabled = false;
          }
          this.loadingMultipleChoice = false;
        }
      } else {
        this.addOrRemoveChoiceRadio(choice);
      }

      this.$emit('input', {
        options: this.multipleValuesCustom,
        comment: this.comment,
        review: this.review,
        position: this.itemId,
        _id: this.idQuestion,
        isMultipleChoiceCustom: true,
      });
    },

    updateOtherComment() {

      let other = '';
      const otherField = this.multipleList.filter((item) => item.isOther);

      if(otherField.length){
        other = (otherField[0].text) ? otherField[0].text : '';

        if(this.lang === 'us'){
          other = (otherField[0].textEN) ? otherField[0].textEN : '';
        } else if(this.lang === 'es'){
          other = (otherField[0].textES) ? otherField[0].textES : '';
        }
      }

      let multipleValues;

      if(otherField.length){
        
        if(this.type === 'checkbox') {

          multipleValues = [...this.multipleValuesCustom, {
            text: this.otherComment,
            optionId: otherField[0]._id,
            subOptions: [],
            id: other
          }];

          const newArray = this.multipleValuesCustom.filter(
            (item) => item !== other,
          );

          multipleValues = [
            ...newArray,
            {
              text: `${other}: ${this.otherComment}`,
              optionId: otherField[0]._id,
              subOptions: [],
              id: other
            },
          ];
          
        } else {
          multipleValues =
          this.multipleValuesCustom.find(item => item.text === other)
          ? [{
            text: `${other}: ${this.otherComment}`,
            optionId: otherField[0]._id,
            subOptions: [],
            id: other
          }]
          : this.multipleValuesCustom;
        }

      } else {
        multipleValues = this.multipleValuesCustom;
      }


      this.$emit('input', {
        options: multipleValues,
        comment: this.comment,
        review: this.review,
        position: this.itemId,
        _id: this.idQuestion,
        isMultipleChoiceCustom: true,
      });
    }
  },
};
</script>
<style lang="scss" scoped>
@import '@/themes/default/variables.scss';
.itens {
  display: flex;
  flex-wrap: wrap;
  justify-content: right;
  margin-bottom: 20px;
}

.arrow-toggle {
  position: absolute;
  left: -40px;
  top: 0;
}

.custom-control-inline {
  display: block;
}

.sub {
  display: none;
}

i.fas.fa-caret-right {
  padding-right: 30px;
}

:checked ~ .sub {
  display: block;
}

//color input

.card-accordion-multiple {
  background: #fff;
  border: none;
}

.btn-light:hover {
  background: #f8f9fa;
}

.icon-checked {
  display: none;
}

.icon-checked-big {
  display: none;
}

.custom-checkbox {
  margin-bottom: 8px;
  border-width: 3px;
  text-align: left;
}

.icon-checkbox-custom {
  margin-top: 5px;
  margin-right: 12px;
}

.container-check {
  display: block;
  position: relative;
  padding-left: 35px;
  margin-bottom: 12px;
  cursor: pointer;
}

.container-check input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 20px;
  width: 20px;
  background-color: #fff;
  border-radius: 2px;
  margin-top: 3px;
  margin-left: 5px;
  border: 1px solid #bababa;
}

.container-check input:checked ~ .checkmark {
  background-color: #4de594;
  border: 1px solid #4de594;
}

.container-check .checkmark:after {
  content: '';
  position: absolute;
  display: none;
  left: 7px;
  top: 4px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

.container-check input:checked ~ .checkmark:after {
  display: block;
}

@media (max-width: 1500px) {
  label.btn.btn-light.btn-lg.active {
    border-color: #07b2f0;
    border-radius: 5px;
    border-width: 2px;
    .icon-checked {
      display: inline;
    }
    .icon-checked-big {
      display: inline;
    }
  }
}

label.btn.btn-light.btn-lg {
  box-shadow: none;
  border-radius: 5px;
  padding-top: 0;
  padding-bottom: 0;
  border-color: #f8f9fa;
  border-width: 1px;
}

@media (min-width: 1501px) {
  label.btn.btn-light.btn-lg.active {
    border-color: #07b2f0;
    border-radius: 5px;
    border-width: 2px;
    .icon-checked {
      display: inline;
      margin-left: 85%;
    }
    .icon-checked-big {
      display: inline;
    }
  }
}

.multiple-question-area {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 4px 0;
  .chips-area {
    display: flex;
    flex-direction: row;
    margin-left: 16px;
    .chip {
      padding: 3px 15px;
      font-size: 16px;
      border-radius: 20px;
      margin: 2px;
      background-color: #3db374;
      border: 1px solid $white;
      color: $white;
    }
  }
}

.sub-chip {
  padding: 3px 15px;
  font-size: 16px;
  border-radius: 20px;
  margin: 2px;
  background-color: $idx-blue;
  border: 1px solid $white;
  color: $white;
}

.chip-multiple {
  padding: 3px 15px;
  font-size: 16px;
  border-radius: 20px;
  margin: 2px;
  background-color: $gray;
  border: 1px solid $white;
  color: $white;
  min-width: 45%;
  width: 45%;
}

.break-word {
  word-break: break-word;
}

.comment-area {
  font-style: italic;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/metrics/multiple-choices-custom/index.vue